import { action, makeObservable, observable } from "mobx";
import userApi from "../modules/Admin/api";

export class UserSettings {
  settings: any = {};

  constructor() {
    makeObservable(this, {
      settings: observable,
      loadSetting: action,
    });
  }

  loadSetting = async (name) => {
    const request = { name };
    const response = await userApi.getUserSettings(request);
    let data;
    try {
      if (response.data.length > 0) {
        data = JSON.parse(response.data[0].value);
      }
    } catch (e) {
      console.log(e);
    }
    this.settings[name] = data;
    return data;
  };

  saveSetting = async (name, value) => {
    const request = { name, value };
    userApi.saveUserSettings(request);
  };
}
const userSettingsStore = new UserSettings();
export default userSettingsStore;
